import React, { useEffect, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { getValue } from "@utils/lodash";
import MoreAdminSvgComponent from "../../../../assets/svg-components/left-menu/more-admin";
import { useNavigate } from "react-router-dom";
import NoAccessPage from "@components/common/NoAccess";
import Loader from "@components/common/Loader";
import Notfound from "@components/Not-Found";
import { QueryRequestHelper } from "@_common/query-request-helper";
import { convertCurrentDate, convertDate } from "@_common/date-helpers";
import { getLegacyTaskFilterList, getLegacyTaskList } from "@services/email-template.service";
import FooterWrapper from "@components/common/FooterWrapper";
import ScrollableDataTable from "@components/ScrollableDatatable/index";
import { tableStatusStyle } from "@_common/colors";
// import EmailLogViewPopup from "./view-popup";
import { EditorState } from "draft-js";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
import { toast } from "react-toastify";
import MoreReportSvgComponent from "../../../../assets/svg-components/left-menu/more-report";
import ReportsNotfoundNoLink from "@components/Page-Not-Found/reports-not-found-nolink";
import ReportsLogsNotfoundNoLink from "@components/Page-Not-Found/reports-logs-not-found";
import { decodeEmail, formatText, snakeToCamelWithSpaces } from "@_common/text-helpers";
import MenuRepositorySvgComponent from "../../../../assets/svg-components/left-menu/menurepo";
import NavigationBar from "@components/NotificationBar";
import { NavLink } from "react-router-dom";
import ModuleFilter from "@components/common/ModuleFilter";
import { downloadLegacyTaskReports } from "@services/import.service";
import SearchableDropdownSelect from "@_common/SearchableDropdown";
import FilterSearchDropdown from "@_common/FilterSearchDropdown";
import SubmenuArrowDownSvgComponent from "../../../../assets/svg-components/left-menu/submenu-arrow-down";

export default function LegacyTaskEvaluator(props: any) {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  const navigate = useNavigate();

  const [templateList, setTemplateList] = useState([]);
  const [isLoading, setIsLoading] = React.useState(true);


  const [filteredAccount, setFilteredAccount] = useState([]);
  const [filteredUnit, setFilteredUnit] = useState([]);
  const [filteredFunction, setFilteredFunction] = useState([]);
  const [pageFilter, setPageFilter] = useState({
    entity_id: "",
    unit_id: "",
    function_id: ""
  });
  /*---------------------------USE Effect----------------------------- */
  useEffect(() => {
    //  const contentState = convertFromRaw(content);

    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
      let dates = params.date ? new Date(params.date) : new Date();
      var from_date = new Date(dates.getFullYear(), dates.getMonth(), 1);
      var to_date = new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
      setFirstDay(from_date);
      setLastDay(to_date);
      getFilterAccount("","");
      getFilterUnit("", "", "");
      getFilterFunction("", "", "", "");
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();

      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
      if (params.from_date && params.to_date) {
        // setDate(new Date(params.date));
        var from_date = new Date(params.from_date);
        var to_date = new Date(params.to_date);
        setFirstDay(from_date);
        setLastDay(to_date);
      }
      setRequest({
        status: getValue(params, `status`, ""),
      });

      getFilterAccount(params.entity_id || "", params.search_text || "");
      getFilterUnit(params.unit_id || "", "", params.entity_id || "");
      getFilterFunction(
        params.function_id || "",
        "",
        params.entity_id || "",
        params.unit_id || ""
      );

      setPageFilter({
        entity_id: getValue(params, `entity_id`, ""),
        unit_id: getValue(params, `unit_id`, ""),
        function_id: getValue(params, `function_id`, "")
      });
    
      // getFilterAccount("","");
      // getFilterUnit("","");
      // getFilterFunction("", "");
    }
  }, [window.location.href, props.permissionAPITriggered]);

  // const getData = async () => {
  //   const urlSearchParams = new URLSearchParams(window.location.search);
  //   const params = Object.fromEntries(urlSearchParams.entries());
  //   let dates = params.date ? new Date(params.date) : new Date();
  //   var from_date = params.from_date
  //     ? params.from_date
  //     : new Date(dates.getFullYear(), dates.getMonth(), 1);
  //   var to_date = params.to_date
  //     ? params.to_date
  //     : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

  //   try {
  //     let payload = {
  //       page_no: params.page_no ? parseInt(params.page_no) : 1,
  //       page_size: params.limit ? parseInt(params.limit) : limit,
  //       search_text: params.search_text,
  //       status: params.status,
  //       request_from: "EVALUATOR",
  //       from_date: convertDate(from_date),
  //       to_date: convertDate(to_date),

  //       entity: getValue(params,`entity_id`, ""),
  //       unit: getValue(params,`unit_id`, ""),
  //       function: getValue(params,`function_id`, ""),
  //     };
  //     let queryRequest = QueryRequestHelper(payload);
  //     setIsLoading(true);
  //     let resp = await getLegacyTaskList(queryRequest);
  //     if (resp) {
  //       setTemplateList(
  //         getValue(resp, `data.tasks`, []).map((item: object) => ({
  //           ...item,
  //           statusName: formatText(getValue(item, `status`, "")),
  //           typeName: snakeToCamelWithSpaces(getValue(item, `type`, "")),
  //           frequencyName: snakeToCamelWithSpaces(
  //             getValue(item, `original_frequency`, "")
  //           ),
  //           created_at: convertCurrentDate(getValue(item, `createdAt`, "")),
  //           legal_due_date: convertCurrentDate(
  //             getValue(item, `legal_due_date`, "")
  //           ),
  //           executor_date: convertCurrentDate(
  //             getValue(item, `executorDate`, "")
  //           ),
  //         }))
  //       );
  //       setTotalCount(getValue(resp, `data.pagination.total`, 0));
  //       setIsLoading(false);
  //     } else {
  //       setIsLoading(false);
  //     }
  //   } catch (error) {
  //     setIsLoading(false);
  //   }
  // };

  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = params.date ? new Date(params.date) : new Date();
    var from_date = params.from_date
      ? params.from_date
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = params.to_date
      ? params.to_date
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

    try {
      // Get the raw URL and extract function_id parameter properly
      const fullUrl = window.location.href;
      let functionId = "";
      
      // Extract function_id from the URL using regex to handle & in the value
      const functionMatch = fullUrl.match(/function_id=([^&]+)/);
      if (functionMatch && functionMatch[1]) {
        functionId = decodeURIComponent(functionMatch[1]);
      }
      
      // For entity_id and unit_id, we can use the standard approach
      const entityId = params.entity_id ? decodeURIComponent(params.entity_id) : "";
      const unitId = params.unit_id ? decodeURIComponent(params.unit_id) : "";
      
      // Directly construct the query string with literal %20 for spaces
      let queryString = `page_no=${params.page_no ? parseInt(params.page_no) : 1}`;
      queryString += `&page_size=${params.limit ? parseInt(params.limit) : limit}`;
      queryString += `&request_from=EVALUATOR`;
      
      if (params.search_text) {
        queryString += `&search_text=${params.search_text.replace(/ /g, '%20')}`;
      }
      
      if (params.status) {
        queryString += `&status=${params.status.replace(/ /g, '%20')}`;
      }
      
      if (entityId) {
        queryString += `&entity=${entityId.replace(/ /g, '%20')}`;
      }
      
      if (unitId) {
        queryString += `&unit=${unitId.replace(/ /g, '%20')}`;
      }
      
      if (functionId) {
        // Replace spaces with %20 and & with %26
        const encodedFunctionId = functionId
          .replace(/ /g, '%20')
          .replace(/&/g, '%26');
        queryString += `&function=${encodedFunctionId}`;
      }
      
      queryString += `&from_date=${convertDate(from_date)}`;
      queryString += `&to_date=${convertDate(to_date)}`;
      
      console.log("Query string:", queryString);
      
      setIsLoading(true);
      let resp = await getLegacyTaskList(queryString);
      if (resp) {
        setTemplateList(
          getValue(resp, `data.tasks`, []).map((item: object) => ({
            ...item,
            statusName: formatText(getValue(item, `status`, "")),
            typeName: snakeToCamelWithSpaces(getValue(item, `type`, "")),
            frequencyName: snakeToCamelWithSpaces(
              getValue(item, `original_frequency`, "")
            ),
            created_at: convertCurrentDate(getValue(item, `createdAt`, "")),
          }))
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(100);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);

    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      // removing null values
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: 1,
      search_text: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };

  /* ---------------------Column Section------------------------------*/
  const columns = React.useMemo(
    () => [
      {
        Header: "TTRN ID",
        accessor: "ttrn_id",
        Cell: ({ row }: any) => {
          return (
            <>
              <NavLink to={`#`}>
                {getValue(row, `original.ttrn_id`, "")}
              </NavLink>
            </>
          );
        },
      },
      //   {
      //     Header: "Type",
      //     accessor: "typeName",
      //   },
      {
        Header: "Legislation",
        accessor: "legislation",
        width: 300,
      },
      {
        Header: "Rule",
        accessor: "rule",
        width: 250,
      },
      {
        Header: "Who",
        accessor: "who",
      },
      {
        Header: "When",
        accessor: "when",
      },
      // {
      //   Header: "Activity",
      //   accessor: "activity",
      // },
      {
        Header: "Activity",
        accessor: "activity",
        width: 350,
        Cell: ({ row }:any) => {
          const complianceActivity = getValue(
            row.original,
            `activity`,
            ""
          );

          const maxCharCount = 100;
          const [showFullContent, setShowFullContent] = useState(false);

          const toggleContent = (e: any) => {
            e.stopPropagation();
            setShowFullContent(!showFullContent);
          };

          const truncatedContent = complianceActivity
            ? complianceActivity.slice(0, maxCharCount)
            : "";
          return (
            <div>
              {showFullContent ? complianceActivity : truncatedContent}
              {getValue(complianceActivity, `length`, 0) > maxCharCount && (
                <span onClick={toggleContent}>
                  {showFullContent ? (
                    <span style={{ color: "#276ef1" }}>
                      {" "}
                      View less{" "}
                      <span
                        style={{
                          transform: "rotate(180deg)",
                          display: "inline-block",
                        }}
                      >
                        {" "}
                        <SubmenuArrowDownSvgComponent color="#276ef1" />{" "}
                      </span>
                    </span>
                  ) : (
                    <span>
                      {" "}
                      ...{" "}
                      <span style={{ color: "#276ef1" }}>
                        View more{" "}
                        <SubmenuArrowDownSvgComponent color="#276ef1" />{" "}
                      </span>
                    </span>
                  )}
                </span>
              )}
            </div>
          );
        },
      },

      //   {
      //     Header: "Frequency",
      //     accessor: "frequencyName"
      //   },
      {
        Header: "Executor Date",
        accessor: "executor_date",
      },
      {
        Header: "Legal Due Date",
        accessor: "legal_due_date",
      },
      {
        Header: "Status",
        accessor: "statusName",
      },
    ],
    []
  );

  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {})
    ).map((item) => parseInt(item));
    let selectedIds =
      templateList.length > 0
        ? templateList.filter((_item: object, index: number) =>
            selectedIndexList.includes(index)
          )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, ""))
      );
    } else {
      setSelectedIDs([]);
    }
  };
  // const rowClick = (obj: object) => {
  //   handleViewEntity(getValue(obj, `original`, ""));
  // };

  const rowClick = (obj: object) => {
    let payload: any = {
      ...params,
    };
    let queryRequest = QueryRequestHelper(payload);
    if (getValue(obj, `original.ttrn_id`, "")) {
      navigate(
        `/repository/legacy-task/evaluator/task-details/${getValue(
          obj,
          `original.ttrn_id`,
          ""
        )}/${getValue(obj, `original.client_task_id`, "")}?${queryRequest}`
      );
    } else {
      toast.error("TTRN ID not available");
    }
  };
  const [check, setCheck] = useState(false);
  const handleRemoveNavItems = () => {
    setCheck(!check);
    setSelectedIDs([]);
  };
  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {
        // style: tableStatusStyle(getValue(rowInfo, `compliance_status`, "")),
      };
    }
    return {};
  };

  const [showUpdatePopup, setShowUpdatePopup] = useState(false);
  const handleViewEntity = async (data: object) => {
    setShowUpdatePopup(true);
    setEditInfo(data);
  };

  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const onEditorStateChange: Function = (editorState: any) => {
    setEditorState(editorState);
  };

  const [editInfo, setEditInfo] = useState({});

  /* -------------------------------------------------------------------------- */
  /*                              Date Routes                                   */
  /* -------------------------------------------------------------------------- */
  const [from_date, setFirstDay] = React.useState(new Date());
  const [to_date, setLastDay] = React.useState(new Date());
  const handleDate = (date: any) => {
    setFirstDay(date[0]);
    setLastDay(date[1]);
  };
  const handleSubmitDate = () => {
    let first: any = convertDate(from_date);
    let last: any = convertDate(to_date);
    if (first && last && first !== "Invalid date" && last !== "Invalid date") {
      let payload: any = {
        from_date: first,
        to_date: last,
      };
      if (payload.from_date && payload.to_date) {
        let queryRequest = QueryRequestHelper(payload);
        navigate(`${window.location.pathname}?${queryRequest}`);
      } else {
        toast.error("Start Date and End Date Required");
      }
    } else {
      toast.error("Please select date");
    }
  };

  //Filter CSS
  const [statusOptions] = useState([
    { value: "ASSIGNED", label: "Assigned" },
    { value: "POSING", label: "Posing" },
    { value: "COMPLIED", label: "Complied" },
    { value: "NON_COMPLIED", label: "Non Complied" },
    { value: "DELAYED", label: "Delayed" },
    { value: "DELAYED_REPORTED", label: "Delayed Reported" },
    { value: "RE_OPENED", label: "Re Opened" },
    { value: "EVENT_NOT_OCCURED", label: "Event Not Occured" },
    { value: "AWAITING_APPROVAL", label: "Awaiting Approval" },
  ]);

  const handleChangeStatus = (name: string, value: string) => {
    if (value) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload = {
        ...params,
        [name]: value,
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload = {
        ...params,
        [name]: "",
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    }
  };

  const [request, setRequest] = useState<any>({
    status: "",
  });

  let status_ID =
    getValue(statusOptions, `length`, 0) > 0 &&
    statusOptions.filter(
      (item: object) =>
        getValue(item, `value`, "") == getValue(request, `status`, "")
    );

  const handleChangeSelectByValue = (e: object, name: string) => {
    setRequest({
      ...request,
      [name]: getValue(e, `value`, "") ? getValue(e, `value`, "") : "",
    });
  };

  /* -------------------------------------------------------------------------- */
  /*                             Download Reports                               */
  /* -------------------------------------------------------------------------- */
  const [downloadLoading, setDownloadLoading] = useState(false);
  const handleDownloadLegacyTaskReport = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");
    let dates = params.date ? new Date(params.date) : new Date();
    var from_date = params.from_date
      ? params.from_date
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = params.to_date
      ? params.to_date
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
    let user: any = JSON.parse(getValue(localStorage, `user`, ""));
    let payload: any = {
      report_type: "LEGACY_TASK_EVALUATOR",
      from_date: convertDate(from_date),
      to_date: convertDate(to_date),
      report_name: "Legacy Task Evaluator",
      report_description: "LEGACY_TASK_EVALUATOR",
      evaluator_email_id: (getValue(user, `email`, "")),
      list:true,
    };
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    setDownloadLoading(true);
    try {
      let resp = await downloadLegacyTaskReports(payload);
      if (resp) {
        setDownloadLoading(false);
        toast.success(getValue(resp, `message`, ""));
        navigate(`/self-compliance-logs/LEGACY_TASK_EVALUATOR`);
      } else {
        setDownloadLoading(false);
      }
    } catch (error) {
      setDownloadLoading(false);
    }
  };

  const handleNavigateLogs = () => {
    navigate(`/self-compliance-logs/LEGACY_TASK_EVALUATOR`);
  };


  const [searchLoading, setSearchLoading] = useState(false);
  const getFilterAccount = async (id: string, value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = params.date ? new Date(params.date) : new Date();
    var from_date = params.from_date
      ? params.from_date
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = params.to_date
      ? params.to_date
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

    
    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      type: "entity",
      from_date: convertDate(from_date),
      to_date: convertDate(to_date),
      entity_id: id,
      search_text: value,
    };

    let queryRequest = QueryRequestHelper(payload);

    try {
      setSearchLoading(true);
      let resp = await getLegacyTaskFilterList(queryRequest);
      if (resp) {
        setFilteredAccount(
          getValue(resp, `data.data`, []).map((item: string, index: number) => ({
            id: `${index + 1}`, // Generate a unique ID (or use a real ID if available)
            value: item,        // Use the company name as the value
            label: item,        // Display the company name in the dropdown
          }))
        );
        
        setSearchLoading(false);
      } else {
        setSearchLoading(false);
      }
    } catch (error) {
      setSearchLoading(false);
    }
  };

  const getFilterUnit = async (id: string, value: string, entity: string,) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = params.date ? new Date(params.date) : new Date();
    var from_date = params.from_date
      ? params.from_date
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = params.to_date
      ? params.to_date
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

    
    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      type: "unit",
      from_date: convertDate(from_date),
      to_date: convertDate(to_date),
      entity: entity,
      search_text: value,

    };

    let queryRequest = QueryRequestHelper(payload);

    try {
      setSearchLoading(true);
      let resp = await getLegacyTaskFilterList(queryRequest);
      if (resp) {
        setFilteredUnit(
          getValue(resp, `data.data`, []).map((item: string, index: number) => ({
            id: `${index + 1}`, // Generate a unique ID (or use a real ID if available)
            value: item,        // Use the company name as the value
            label: item,        // Display the company name in the dropdown
          }))
        );
        
        setSearchLoading(false);
      } else {
        setSearchLoading(false);
      }
    } catch (error) {
      setSearchLoading(false);
    }
  };

  const getFilterFunction = async (id: string, value: string, entity: string, unit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = params.date ? new Date(params.date) : new Date();
    var from_date = params.from_date
      ? params.from_date
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = params.to_date
      ? params.to_date
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

    
    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      type: "functionhead",
      from_date: convertDate(from_date),
      to_date: convertDate(to_date),
      entity: entity,
      unit: unit,
      search_text: value,
    };

    let queryRequest = QueryRequestHelper(payload);

    try {
      setSearchLoading(true);
      let resp = await getLegacyTaskFilterList(queryRequest);
      if (resp) {
        setFilteredFunction(
          getValue(resp, `data.data`, []).map((item: string, index: number) => ({
            id: `${index + 1}`, // Generate a unique ID (or use a real ID if available)
            value: item,        // Use the company name as the value
            label: item,        // Display the company name in the dropdown
          }))
        );
        
        setSearchLoading(false);
      } else {
        setSearchLoading(false);
      }
    } catch (error) {
      setSearchLoading(false);
    }
  };

  const handleTriggerAccount = async (value: string) => {
    
    if (!value) {
      setPageFilter({
        ...pageFilter,
        entity_id: "",
      });
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      delete params.entity_id;
      delete params.unit_id;
      delete params.function_id;
      let payload = {
        ...params,
        d_page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      setPageFilter({
        ...pageFilter,
        entity_id: value,
      });
      getFilterAccount("", value);
      getFilterUnit("", "", "");
      getFilterFunction("", "", "", "");

    }
  };

  const handleTriggerUnit = async (value: string, entity: string) => {
    if (!value) {
      setPageFilter({
        ...pageFilter,
        unit_id: "",
      });
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      delete params.unit_id;
      delete params.function_id;
      let payload = {
        ...params,
        d_page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      setPageFilter({
        ...pageFilter,
        unit_id: value,
      });
      getFilterUnit("", value, entity);
      getFilterFunction("", "", entity, "");
    }
  };

  const handleTriggerFunction = async (value: string, entity: string, unit: string) => {
    if (!value) {
      setPageFilter({
        ...pageFilter,
        function_id: "",
      });
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      delete params.function_id;
      let payload = {
        ...params,
        d_page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      setPageFilter({
        ...pageFilter,
        function_id: value,
      });
      getFilterFunction("", value, entity, unit);

    }
  };
  
  // const handleChangeFilter = (name: string, value: string) => {
  //   const urlSearchParams = new URLSearchParams(window.location.search);
  //   const params = Object.fromEntries(urlSearchParams.entries());
  //   let newParams = { ...params };
  
  //   // Reset dependent filters based on the changed filter
  //   if (name === "entity_id") {
  //     if (!value) {
  //       // Clear unit and function if entity is cleared
  //       delete params.unit_id;
  //       delete params.function_id;
  //       setPageFilter((prev) => ({
  //         ...prev,
  //         entity_id: "",
  //         unit_id: "",
  //         function_id: "",
  //       }));
  //     } else {
  //       newParams[name] = value;
  //       // Keep unit and function only if they exist
  //       setPageFilter((prev) => ({
  //         ...prev,
  //         [name]: value,
  //       }));
  //     }
  //   } else if (name === "unit_id") {
  //     if (!value) {
  //       // Clear function if unit is cleared
  //       delete params.function_id;
  //       setPageFilter((prev) => ({
  //         ...prev,
  //         unit_id: "",
  //         function_id: "",
  //       }));
  //     } else {
  //       newParams[name] = value;
  //       setPageFilter((prev) => ({
  //         ...prev,
  //         [name]: value,
  //       }));
  //     }
  //   } else if (name === "function_id") {
  //     if (!value) {
  //       delete params.function_id;
  //       setPageFilter((prev) => ({
  //         ...prev,
  //         function_id: "",
  //       }));
  //     } else {
  //       newParams[name] = value;
  //       setPageFilter((prev) => ({
  //         ...prev,
  //         [name]: value,
  //       }));
  //     }
  //   }
  
  //   // Update URL with new parameters
  //   const queryRequest = QueryRequestHelper(newParams);
  //   navigate(`${window.location.pathname}?${queryRequest}`);
  // };

  const handleChangeFilter = (name: string, value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let newParams = { ...params };
  
    // Reset dependent filters based on the changed filter
    if (name === "entity_id") {
      if (!value) {
        // Clear unit and function if entity is cleared
        delete newParams.unit_id;
        delete newParams.function_id;
        setPageFilter((prev) => ({
          ...prev,
          entity_id: "",
          unit_id: "",
          function_id: "",
        }));
      } else {
        newParams[name] = value;
        setPageFilter((prev) => ({
          ...prev,
          [name]: value,
        }));
      }
    } else if (name === "unit_id") {
      if (!value) {
        // Clear function if unit is cleared
        delete newParams.function_id;
        setPageFilter((prev) => ({
          ...prev,
          unit_id: "",
          function_id: "",
        }));
      } else {
        newParams[name] = value;
        setPageFilter((prev) => ({
          ...prev,
          [name]: value,
        }));
      }
    } else if (name === "function_id") {
      if (!value) {
        delete newParams.function_id;
        setPageFilter((prev) => ({
          ...prev,
          function_id: "",
        }));
      } else {
        newParams[name] = value;
        setPageFilter((prev) => ({
          ...prev,
          [name]: value,
        }));
      }
    }

    // Create a new URLSearchParams object and properly set each parameter
    const searchParams = new URLSearchParams();
    Object.entries(newParams).forEach(([key, val]) => {
      if (val) searchParams.set(key, val);
    });
    
    navigate(`${window.location.pathname}?${searchParams.toString()}`);
  };


  return (
    <>
      <DashboardLayout
        permissions={getValue(props, `tabPermissionList`, [])}
        subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
      >
        <>
          {/* {getValue(selectedIDs, `length`, 0) > 0 && (
              <NavigationBar
                selectedIDs={selectedIDs}
                // isMarkInactiveSectionVisible={true}
                handleChangeActiveStatus={handleChangeActiveStatus}
                text={"MARK INACTIVE"}
                handleRemoveNavItems={handleRemoveNavItems}
                handleNavigate={handleNavigate}
                permissions={props.permissions}
                licenseIDs={licenseIDs}
                // assignTask
                masterNav={"false"}
                showUpdatePopup={handleUpdateTask}
                handleUpdateStatus={handleUpdateStatus}
                // assignedTaskActive={true}
                hideConfigure={true}
                multi={true}
                filterOptions={filterOptions}
                isUpdateTaskVisible={
                  getValue(selectedIDs, `length`, 0) === 1 ? true : false
                }
              />
            )} */}
          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="header-parent-icon-holder">
                <MenuRepositorySvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Legacy Task
                </h6>
                <h4 className="dashbaord-wrapper__header-title">Evaluator</h4>
              </div>
            </div>

            <div className="d-flex align-items-center">
              <RightMenuHeaders
                licenseStyleCalendar={true}
                //search
                isSearch={true}
                searchInput={search_text}
                showSearchTextbox={showSearchTextbox}
                toggleSearch={toggleSearch}
                toggleSearchClose={toggleSearchClose}
                handleChangeSearch={handleChangeSearch}
                // date range
                dateRange={true}
                from_date={from_date}
                to_date={to_date}
                handleDate={handleDate}
                handleSubmitDate={handleSubmitDate}
                //Line Seperator of button
                lineSeperator={true}
                downloadLegacyTaskReport={true}
                handleDownloadLegacyTaskReport={
                  handleDownloadLegacyTaskReport
                }
                downloadLoading={downloadLoading}
                //logs section
                viewDownloadedSelfComplianceReports={true}
                handleNavigateLogs={handleNavigateLogs}
              />
            </div>
          </div>
          <div className={`main-page-layout-wrapper has-module-filter`}>
            <div>

            <section className="d-flex align-items-center justify-content-between mb-3">
                <div className="d-flex justify-content-between">
                  <div className="filter-form-wrappper__location d-flex filter-legacy-task">
                    <div className="filter-form-wrappper__location-form-group form-group mb-0 d-flex module-filter-wrapper width-20">
                      <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                        <label
                          htmlFor="country_id"
                          className="floating-label ms-0"
                        >
                          Entity
                        </label>

                        <FilterSearchDropdown
                          placeholder="Search Entity"
                          options={filteredAccount}
                          searchLoading={searchLoading}
                          handleChange={(val: any) => handleTriggerAccount(val)}
                          handleClick={(e: any) => handleChangeFilter("entity_id", e.value)}
                          value={filteredAccount.find(
                            (item: any) => item.value === pageFilter.entity_id
                          )}
                          label="label" // Maps to `label` in options
                          id="id" // Maps to `id` in options
                          name="Group"
                        />
                      </div>
                    </div>

                    <div className="filter-form-wrappper__location-form-group form-group mb-0 d-flex module-filter-wrapper width-20">
                      <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                        <label
                          htmlFor="country_id"
                          className="floating-label ms-0"
                        >
                          Unit
                        </label>

                        <FilterSearchDropdown
                          placeholder="Search Unit"
                          options={filteredUnit}
                          searchLoading={searchLoading}
                          handleChange={(val: any) => handleTriggerUnit(val, getValue(params, `entity_id`, ""))}
                          handleClick={(e: any) => handleChangeFilter("unit_id", e.value)}
                          value={filteredUnit.find(
                            (item: any) => item.value === pageFilter.unit_id
                          )}
                          label="label" // Maps to `label` in options
                          id="id" // Maps to `id` in options
                          name="Unit"
                        />
                      </div>
                    </div>

                    <div className="filter-form-wrappper__location-form-group form-group mb-0 d-flex module-filter-wrapper width-20">
                      <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                        <label
                          htmlFor="country_id"
                          className="floating-label ms-0"
                        >
                          Function
                        </label>

                        <FilterSearchDropdown
                          placeholder="Search Function"
                          options={filteredFunction}
                          searchLoading={searchLoading}
                          handleChange={(val: any) => handleTriggerFunction(val, getValue(params, `entity_id`, ""), getValue(params, `unit_id`, ""))}
                          handleClick={(e: any) => handleChangeFilter("function_id", e.value)}
                          value={filteredFunction.find(
                            (item: any) => item.value === pageFilter.function_id
                          )}
                          label="label" // Maps to `label` in options
                          id="id" // Maps to `id` in options
                          name="Unit"
                        />
                      </div>
                    </div>

                    {/* Status Code */}
                    <div className="filter-form-wrappper__location-form-group form-group mb-0 d-flex module-filter-wrapper width-20">
                      <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                        <label
                          htmlFor="country_id"
                          className="floating-label ms-0"
                        >
                          Status
                        </label>
                        <SearchableDropdownSelect
                          placeholder={"Choose Status"}
                          options={statusOptions}
                          handleChange={(e: any) =>
                            handleChangeStatus(
                              "status",
                              getValue(e, `value`, "")
                            )
                          }
                          handleClick={(e: any) =>
                            handleChangeStatus(
                              "status",
                              getValue(e, `value`, "")
                            )
                          }
                          value={
                            getValue(statusOptions, `length`, 0) > 0 &&
                            statusOptions.find(
                              (item: object) =>
                                getValue(item, `value`, "") ===
                                getValue(params, `status`, "")
                            )
                          }
                          className="form-control"
                          name="status"
                          label="label"
                          id="id"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              {/* <ModuleFilter
                filterStatus
                handleChangeStatus={handleChangeStatus}
                status_ID={status_ID}
                statusOptions={statusOptions}
                handleChangeSelectByValue={handleChangeSelectByValue}
              /> */}
            </div>

            {!isLoading &&
            !getValue(props, `subTabPermissionList`, []).includes(
              "repository_legacy_task_evaluator"
            ) ? (
              <NoAccessPage />
            ) : (
              <section>
                {isLoading || !props.permissionAPITriggered ? (
                  <Loader />
                ) : getValue(templateList, `length`, 0) > 0 ? (
                  <>
                    <ScrollableDataTable
                      columns={columns}
                      data={templateList}
                      getTableState={getTableState}
                      rowClick={rowClick}
                      check={check}
                      selectedIDs={selectedIDs}
                        checkboxlogo
                      getTrProps={getTrProps}
                    />

                    <FooterWrapper
                      list={templateList}
                      totalCount={totalCount}
                      limit={limit}
                      page_no={page_no}
                      handleChangePagination={handleChangePagination}
                      handleChangeLimit={handleChangeLimit}
                    />
                  </>
                ) : (
                  <>
                    <div className={`main-page-layout-wrapper`}>
                      {Object.keys(params).length !== 0 ? (
                        <ReportsLogsNotfoundNoLink />
                      ) : (
                        <ReportsLogsNotfoundNoLink />
                      )}
                    </div>
                  </>
                )}
              </section>
            )}
          </div>
        </>
      </DashboardLayout>
    </>
  );
}
